import { observer } from 'mobx-react-lite'
import React from 'react'
import { AssignNumberCommon } from 'entities/Phone'
import { useAddNumberFromAppStepsContext } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppStepsContext'

export const AssignNumber = observer(() => {
  const { assignNumberStore } = useAddNumberFromAppStepsContext()

  return (
    <>
      <AssignNumberCommon store={assignNumberStore} />
    </>
  )
})
